import { __assign, __awaiter, __generator, __read } from "tslib";
import { CampaignParser, isCampaignEvent, isSessionExpired } from '@amplitude/analytics-client-common';
import { createCampaignEvent, getDefaultExcludedReferrers, getStorageKey, isNewCampaign } from './helpers';
export var webAttributionPlugin = function (options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var campaignPerSession = {};
    var plugin = {
        name: '@amplitude/plugin-web-attribution-browser',
        type: 'before',
        setup: function (config, amplitude) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var pluginConfig, storage, storageKey, _c, currentCampaign, previousCampaign, isMostRecentSessionExpired, sessionId, campaignEvent;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            pluginConfig = __assign({ initialEmptyValue: 'EMPTY', resetSessionOnNewCampaign: false, excludeReferrers: getDefaultExcludedReferrers((_a = config.cookieOptions) === null || _a === void 0 ? void 0 : _a.domain) }, options);
                            config.loggerProvider.log('Installing @amplitude/plugin-web-attribution-browser.');
                            storage = config.cookieStorage;
                            storageKey = getStorageKey(config.apiKey, 'MKTG');
                            return [4 /*yield*/, Promise.all([
                                    new CampaignParser().parse(),
                                    storage.get(storageKey),
                                ])];
                        case 1:
                            _c = __read.apply(void 0, [_d.sent(), 2]), currentCampaign = _c[0], previousCampaign = _c[1];
                            isMostRecentSessionExpired = isSessionExpired(config.sessionTimeout, config.lastEventTime);
                            // Check if attribution event will be tracked
                            if (isNewCampaign(currentCampaign, previousCampaign, pluginConfig, isMostRecentSessionExpired)) {
                                sessionId = (_b = config.sessionId) !== null && _b !== void 0 ? _b : -1;
                                // Check if most recent session ID is expired OR if `resetSessionOnNewCampaign` set to true
                                // If yes, set a new session ID
                                if (isMostRecentSessionExpired || pluginConfig.resetSessionOnNewCampaign) {
                                    sessionId = Date.now();
                                    amplitude.setSessionId(sessionId);
                                    if (pluginConfig.resetSessionOnNewCampaign) {
                                        config.loggerProvider.log('Created a new session for new campaign.');
                                    }
                                }
                                campaignEvent = createCampaignEvent(currentCampaign, pluginConfig);
                                campaignEvent.session_id = sessionId;
                                // Cache campaign event with its associated session ID as key
                                campaignPerSession[sessionId] = campaignEvent;
                                // Additionally, track the same event
                                amplitude.track(campaignEvent);
                                void storage.set(storageKey, currentCampaign);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        execute: function (event) { return __awaiter(_this, void 0, void 0, function () {
            var campaignEvent;
            return __generator(this, function (_a) {
                if (event.session_id) {
                    campaignEvent = campaignPerSession[event.session_id];
                    if (campaignEvent) {
                        // If yes, merge first seen event with with campaign event.
                        // It is possible that `event` is equal to `campaignEvent`
                        // when `campaignEvent` is what is first passed to `execute`.
                        event.user_properties = mergeDeep(campaignEvent.user_properties, event.user_properties);
                        event.event_properties = __assign(__assign({}, event.event_properties), campaignEvent.event_properties);
                        if (Object.keys(event.event_properties).length === 0) {
                            delete event.event_properties;
                        }
                        // Remove cached campaign event
                        delete campaignPerSession[event.session_id];
                    }
                    else if (isCampaignEvent(event)) {
                        // If no campaign event event cache for session ID exists,
                        // then campaign event has been merged with another event
                        // and this is a dupe that must be dropped.
                        return [2 /*return*/, null];
                    }
                }
                return [2 /*return*/, event];
            });
        }); },
    };
    return plugin;
};
var isObject = function (item) {
    return Boolean(item) && typeof item === 'object' && !Array.isArray(item);
};
var mergeDeep = function (target, source) {
    var _a, _b;
    if (isObject(target) && isObject(source)) {
        for (var key in source) {
            if (isObject(source[key])) {
                if (!target[key]) {
                    Object.assign(target, (_a = {}, _a[key] = {}, _a));
                }
                mergeDeep(target[key], source[key]);
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                Object.assign(target, (_b = {}, _b[key] = source[key], _b));
            }
        }
    }
    return target;
};
//# sourceMappingURL=web-attribution.js.map